
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export interface PaymentMethodSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export const PaymentMethodSelector = ({ value, onChange }: PaymentMethodSelectorProps) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select payment method" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="bank_transfer">Bank Transfer</SelectItem>
        <SelectItem value="cash">Cash</SelectItem>
        <SelectItem value="check">Check</SelectItem>
        <SelectItem value="credit_card">Credit/Debit Card</SelectItem>
        <SelectItem value="online">Online Payment</SelectItem>
      </SelectContent>
    </Select>
  );
};
